<!--
The landing page seen upon logging in

@author ab557z / crm4f
-->
<template>
  <div id="contain" class="container" style="background-color:#fff">

    <Logo style="margin-bottom:15px;" :unreadNum="unreadNotifications" :showNotif="1===1" :showWelcome="1===1" :name="format(name)"/>

    <InclusiveNotice v-if="showNotice" :canDismiss="1===1" />

    <Reminder v-if="cacheClearNeeded" category="7" :link="{ name: 'Log Out', path: '/clearcache' }" />

    <!-- carousel section for daily events -->
    <section class="eventsContainer">
      <div style="display:flex;" class="sectionHeader">
        <h1 id="myClassesTxt">My classes</h1>
        <span id="todayTxt">Today</span>
      </div>
      <EventsSlide />
    </section>

    <!-- moodle link -->
    <section class="moodleContainer">
      <div style="display:flex; margin-bottom: 5px;" class="sectionHeader">
        <h1 class="headingTxt">Moodle</h1>
      </div>
      <div class="viewButtonContainer">
        <button type="button" class="viewButton primaryButton" @click="go('https://moodle.gla.ac.uk/login/index.php')">Open Moodle<font-awesome-icon style="font-size: 16px; margin-left: 5px;" icon="external-link" size="lg"></font-awesome-icon></button>
      </div>
    </section>

    <!-- carousel section for findaspace -->
    <section class="spacesContainer">
      <div style="margin-bottom:15px;" class="sectionHeader">
        <h1 class="headingTxt">Find a space</h1>
        <span>Book a room or check availability of drop-in study spaces on campus</span>
      </div>
      <FeatureSwitch name="findaspace_dropin">
        <template v-slot:alternate>
        <!-- what to show if the user is excluded from the feature ... -->
          <OutOfService text="Sorry, this feature is currently under maintenance." />
        </template>
        <SpacesSlide :preferredSpaceNames="['Main Library', 'James McCune Smith Learning Hub']"/>
      </FeatureSwitch>
    </section>

    <!-- carousel section for more features -->
    <section class="moreFtrsContainer">
      <div style="color:#fff" class="sectionHeader">
        <h1 class="headingTxt">More features</h1>
      </div>
      <MoreFeaturesSlide/>
    </section>

    <!-- 29/03/2022 news swipe has been retired -->

    <div id="pusher"></div>
    <Footer active="index"/>

  </div>
</template>

<script setup>
import FeatureSwitch from '@/components/FeatureSwitch.vue'
import Logo from '@/components/Logo.vue'
import OutOfService from '@/components/OutOfService.vue'
import EventsSlide from '@/components/homepage/EventsSlide.vue'
import SpacesSlide from '@/components/homepage/SpacesSlide.vue'
import InclusiveNotice from '@/components/homepage/InclusiveNotice.vue'

import Reminder from '@/components/homepage/Reminder.vue'
import MoreFeaturesSlide from '@/components/homepage/MoreFeaturesSlide.vue'
import * as lst from '@/components/localStorage.js'

import $ from 'jquery'
import axios from 'axios'
import Footer from '@/components/FooterMenu.vue'

import {onMounted, ref} from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

// const date = ref(new Date().setTime(Date.now))
const hasRoomBookingAccess = ref(false)
const unreadNotifications = ref(0)
const name = ref('')
// const randCount = ref(0)
// const banners = ref({})
// const bannerKey = ref('')
//const keyDate = ref({})
const cacheClearNeeded = ref(lst.getValue('cacheClearNeeded'))
const showNotice = ref(lst.getValue('showHomepageNotice'))

onMounted(() => {
  let data = lst.getAll()
  const userData = data
  updateData()

  var time = Date.now()
  var diff = time - userData['indexTime']
  var refreshRate = 180000
  if (diff > refreshRate) { // was >
    axios.get('/timetable/index', { withCredentials: true })
    .then(response => {
      unreadNotifications.value = response.data.unreadNotifications

          console.log('--- idb data ---')
          const testVals = {
            'unreadNotifications': response.data.unreadNotifications,
            'hasChanges': response.data.hasChanges,
            'indexTime': time
          }
          lst.setValues(testVals)
        })
    } // if (diff > refreshRate)

    if (process.env.VUE_APP_MODE === 'hybrid') {
      window.FirebasePlugin.onMessageReceived(function (message) {
        if (message.tap) {
          router.push('/notifications')
        }
      })
    }
    window.addEventListener('popstate', removeBackdrop)
    const ua = window.navigator.userAgent
    const ie11 = ua.indexOf('rv:11.0') !== -1
    if (ie11) { // detect it's IE11 (deprecated as IE's out of support as of June 2022)
      window.addEventListener('hashchange', ieFix)
    }
})

function updateData () {
  console.log('this.hasRoomBookingAccess <= ' + lst.getValue('hasRoomBookingAccess'))
  console.log('this.name <= ' + lst.getValue('name'))
  hasRoomBookingAccess.value = lst.getValue('hasRoomBookingAccess') === true
  unreadNotifications.value = lst.getValue('unreadNotifications')
  name.value = lst.getValue('name')
}

function format (name) {
  if (typeof name !== 'undefined' && name != null) {
    return name.split(',')[0]
  }
  return ''
}

function removeBackdrop () {
  $('.modal-backdrop').remove()
}

function ieFix () {
  window.location.reload()
}

function go (link) {
  window.location.href = link
}
</script>

<style>
section {
  margin-top: 25px;
  margin-bottom: 25px;
  padding-right: 20px;
  padding-left: 20px;
  color: #003865;
}

.moreFtrsContainer {
  background-color:#003865;
  display: flex;
  flex-flow: column;
  margin-bottom: 0px;
  padding-bottom: 20px;
}

.sectionHeader {
  margin-top: 10px;
}

.viewButtonContainer {
  width: 100%;
  display: flex;
  justify-content: center;
}

.primaryButton {
  background: #003865 !important;
  color:#FFFFFF !important;
}

.titleLand {
  margin-left: 0;
}

#myClassesTxt {
  font-weight: bold;
  margin: auto;
  text-align: left;
  width: 75%;
}

#todayTxt {
  margin: auto;
  width: 25%;
  text-align: right;
  font-weight: bold;
}

.headingTxt {
  font-weight: bold;
}

#contain {
padding:0px;
font-family: PTSans;
}

#pusher {
  height: 60px;
  /* notch height on iOS 11.0 */
  margin-top: constant(safe-area-inset-bottom);
  /* notch height on iOS 11+ */
  margin-top: env(safe-area-inset-bottom);
}

div.scrollover {
  overflow-x:auto;
  overflow-y:hidden;
  white-space: nowrap;
  height: fit-content !important;
  -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
.scrollover::-webkit-scrollbar {
  display: none;
}

@media (min-height: 1100px) {
  .moreFtrsContainer {
    height: 50vh;
  }
}
</style>
